import {useState} from 'react';
import {Moment} from 'moment';
import {useParams} from 'react-router-dom';
import {TinyHeader} from '../../../../../../../components/tiny-header/tiny-header';
import {SeniorStatisticsDashboard} from '../../../../../../../components/senior-statistics-dashboard/senior-statistics-dashboard';
import {DateRangeInput} from '../../../../../../../components/date-range-input/date-range-input';
import {CaregiverMode, LocalStorageKey} from '../../../../../../../enums';
import {
  calcEndDateByRange,
  calcStartDateByRange,
  DateRangeType,
} from '../../../../../../../components/date-range-input/date-range-utils';

export default function SeniorStatisticsSystemAdministratorOfficeScreen() {
  // Get params
  let {id}: {id?: string} = useParams();
  const [startDate, setStartDate] = useState(getInitialStartDate);
  const [endDate, setEndDate] = useState(getInitialEndDate);

  return (
    <>
      <TinyHeader
        middle={
          <DateRangeInput
            startDate={startDate}
            endDate={endDate}
            onChange={(startDate, endDate, range) => {
              setStartDate(startDate);
              setEndDate(endDate);
              if (range !== 'custom')
                localStorage.setItem(LocalStorageKey.EntityGeneralChartsRange, range);
            }}
          />
        }
      />
      <SeniorStatisticsDashboard
        caregiverMode={CaregiverMode.SystemAdministrator}
        seniorId={id || ''}
        startDate={startDate}
        endDate={endDate}
        notShowUpdateButton
      />
    </>
  );
}

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------

function getInitialStartDate(): Moment {
  // Get stored range
  const storedRange = localStorage.getItem(
    LocalStorageKey.GeneralChartsRange
  ) as DateRangeType | null;

  // Get start date by range
  return calcStartDateByRange(storedRange ?? '7d');
}

function getInitialEndDate(): Moment {
  // Get stored range
  const storedRange = localStorage.getItem(
    LocalStorageKey.GeneralChartsRange
  ) as DateRangeType | null;

  // Get start date by range
  return calcEndDateByRange(storedRange ?? '7d');
}
